export default (type, permissions) => {
  return permissions.includes(type);
};
